import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DateRangeSelector from './DateRangeSelector';
import { useTranslation } from 'react-i18next';

const DateSelector = ({ name, value, optionsList, handleChange, handleClose }) => {
  const { t } = useTranslation();
  const [showDateRangeSelector, setShowDateRangeSelector] = useState(false);

  useEffect(() => {
    if (value.type === 'custom') setShowDateRangeSelector(true);
  }, []);

  return (
    <div className='d-flex'>
      <div className='px-2 dropdown-options'>
        {optionsList.map((o, i) => (
          <div
            key={i}
            className={`item ${value.type === o.value ? 'selected' : ''}`}
            onClick={() => {
              setShowDateRangeSelector(o.value === 'custom');

              if (o.value !== 'custom') {
                handleChange(name, { type: o.value, range: [] });
                handleClose();
              }
            }}
          >
            {t(o.displayValue)}
          </div>
        ))}
      </div>
      {showDateRangeSelector && (
        <DateRangeSelector
          name={name}
          value={value.range}
          onChange={(name, range) => {
            handleChange(name, { type: 'custom', range });
          }}
          onClose={handleClose}
        />
      )}
    </div>
  );
};

DateSelector.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.object.isRequired,
  optionsList: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default DateSelector;
